import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';
import Popup from '@root/core/components/Popup';
import useDebounce from '@root/core/hooks/useDebounce';
import ShippingServices from '@root/modules/Sellers/Shipping/services/shipping';
import {
  AutoComplete,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Spin
} from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import { AutocompletePrediction } from 'react-places-autocomplete';
import { useHistory, useParams } from 'react-router';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from 'use-places-autocomplete';
import ProductService from '../../Product/services/product';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import commentService from '@root/core/components/CommentTabs/commentService';
import { placesAutocomplete } from '@root/utils/helpers/placesAutocomplete';
import { getStatusSeller } from '../helpers';

const UpdateShipping = () => {
  const [info, setInfo] = useState<{ updated_at: string; status: string }>({
    updated_at: moment(new Date())
      .utc(true ?? 9)
      .format('YYYY-MM-DD hh:mm:ss A'),
    status: ''
  });
  const history = useHistory();
  const { shippingid, commentId }: any = useParams();
  const [warehouse, setWarehouse] = useState('');
  const [inputProduct, setInputProduct] = useState('');
  const [indexProduct, setIndexProduct] = useState(0);
  const [channelUse, setChannelUse] = useState<string>('');
  const [order, setOrder] = useState('');
  const [option, setOption] = useState([] as any);
  const [optionOrder, setOptionOrder] = useState([] as any);
  const [form] = Form.useForm();
  const [searchValue, setSearchValue] = useState<string>('');
  const [remainQuantity, setRemainQuantity] = useState<number[]>([0, 0]);
  const [idWarehouse, setIdWarehouse] = useState(0);
  const [suggestProduct, setSuggestProduct] = useState([] as any);
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const [coordinates, setCoordinates] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 0,
    lng: 0
  });
  const debounc = useDebounce(warehouse, 1000);
  const debounced = useDebounce(inputProduct, 1000);
  const debounceOrder = useDebounce(order, 1000);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalNavigateOpen, setIsModalNavigateOpen] = useState(false);
  const {
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    debounce: 300
  });

  const ref = useOnclickOutside(() => {
    clearSuggestions();
  });
  const [selectUse, setSelectUse] = useState(true);

  const handleInput: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (form.getFieldError('detailAddress').length === 0) {
      setCoordinates({
        lat: 0,
        lng: 0
      });
      form.setFieldsValue({
        postalCode: '',
        country: '',
        detailAddress: '',
        city: '',
        state: '',
        shippingAddress: ''
      });
      setValue(e.target.value);
    } else {
      clearSuggestions();
    }
    setSearchValue(e.target.value);
  };

  const listBreadcrumb = [
    {
      tittle: '배송 관리',
      url: '/admin/seller/shipping'
    },
    {
      tittle: '배송 등록',
      url: '/admin/seller/shipping'
    }
  ];

  const handleSelectAddr =
    ({ description }: AutocompletePrediction) =>
    async () => {
      setValue(description, false);
      clearSuggestions();

      const results = await getGeocode({ address: description });
      const { lat, lng } = getLatLng(results[0]);
      setCoordinates({
        lat,
        lng
      });
      setSearchValue(description);
      form.setFieldsValue({
        shippingAddress: description
      });
      const address_components = results[0].address_components;
      const { COUNTRY, ZIP_CODE, TOWN, CITY, STATE, NEAREST_ROAD } =
        placesAutocomplete.getAddressComponent(address_components, [
          'COUNTRY',
          'TOWN',
          'CITY',
          'STATE',
          'ZIP_CODE',
          'NEAREST_ROAD'
        ]);

      form.setFieldsValue({
        detailAddress: results[0].formatted_address.split(',')[0]!,
        country: COUNTRY!,
        postalCode: ZIP_CODE!,
        state: STATE ?? CITY!,
        city: TOWN ?? CITY!,
        street: NEAREST_ROAD!
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion: any) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text }
      } = suggestion;
      return (
        <li key={place_id} onClick={handleSelectAddr(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  const getListProduct = async (warehouseId: number, productName: string) => {
    if (idWarehouse !== 0) {
      let productReset = form.getFieldValue('product');
      productReset[indexProduct] = {
        id: 0,
        productName: inputProduct ?? productReset[indexProduct].productName,
        sku: '',
        eanUpc: '',
        stockQuantity: 0
      };
      form.setFieldsValue({
        product: productReset
      });
      let remain = Array.isArray(remainQuantity)
        ? JSON.parse(JSON.stringify(remainQuantity))
        : [remainQuantity];
      remain[indexProduct] = 0;
      setRemainQuantity(remain);
      const listProduct = await ShippingServices.getProduct(
        warehouseId,
        productName
      );
      let productuse = form
        .getFieldValue('product')
        .map((item: any) => item.id);
      let listProductUse = listProduct.data
        .filter((item: any) => !productuse.includes(item.id))
        .map((ite: any) => {
          return {
            value: ite.productName,
            key: ite.id,
            label: (
              <div
                key={ite.id}
                onClick={() => {
                  let a = form.getFieldValue('product');
                  a[indexProduct].productName = ite.productName;
                  form.setFieldsValue({
                    product: a
                  });
                  getDetailProduct(ite.id);
                  // setIdWarehouse(sug.id)
                  setSuggestProduct([]);
                }}
              >
                 <strong>{ite.productName + ' - ' + ite.sku}</strong>
              </div>
            )
          };
        });
      setSuggestProduct(listProductUse);
      // setInputProduct('');
    }
  };

  useEffect(() => {
    getListProduct(idWarehouse, inputProduct);
  }, [debounced, idWarehouse, indexProduct]);

  const getListWarehouse = async (WarehouseName: string) => {
    setOption([]);
    setIdWarehouse(0);
    form.setFieldsValue({
      product: [
        {
          id: 0,
          productName: '',
          sku: '',
          eanUpc: '',
          stockQuantity: 0
        }
      ]
    });
    setRemainQuantity([0, 0]);
    const listWarehouse = await ShippingServices.getWarehouse(WarehouseName);
    let listUse =
      !!listWarehouse && listWarehouse?.data.length > 0
        ? listWarehouse.data.map((item: any) => ({
            name: item.name,
            id: item.id
          }))
        : [];
    let a = listUse.map((item: any) => {
      return {
        key: item.id,
        value: item.name,
        label: (
          <div
            onClick={() => {
              setIdWarehouse(item.id);
            }}
          >
            {item.name}
          </div>
        )
      };
    });
    setOption(a);
  };

  const UpdateShipping = async (status: string) => {
    try {
      // if (channelUse !== 'Amazoins') {
      form.validateFields();
      let isTouch = form.isFieldsTouched([
        'orderNumber',
        'orderDate',
        'buyerName',
        'buyerEmail',
        'recipientName',
        'recipientPhone',
        'warehouse',
        'shippingAddress',
        'detailAddress',
        'country',
        'city',
        'state',
        'recipientCountryCode',
        'isDangerousProduct',
        'shippingMethod',
        'sellerComment'
      ]);
      let isProductValid = form
        .getFieldValue('product')
        .every((item: any) => Number(item.stockQuantity) > 0);

      if (!isProductValid) {
        message.error(
          'Please enter quantity of product for create shipping > 0'
        );
        return;
      }
      if (!isTouch || !idWarehouse) {
        message.error('Please enter for input required');
        return;
      }
      let body: any = form.getFieldsValue();
      body.warehouseId = Number(idWarehouse);
      body.packagingMethod =
        Array.isArray(body.packagingMethod) &&
        !body.packagingMethod.includes('Directinput')
          ? body.packagingMethod.filter((item: any) => !!item).join()
          : body.packageInput;
      body.orderProducts = form.getFieldValue('product').map((item: any) => ({
        productId: item.id,
        orderQuantity: item.stockQuantity
      }));
      // body.packagingMethod =
      body.dangerous = Number(body.dangerous) === 1;
      body.sellerStatus = status;
      // delete body.packagingMethod
      delete body.product;
      delete body.packageInput;
      await ShippingServices.postUpdateShipping(shippingid, body);
      await commentService.editedRequest(commentId);
      // setIdDetail(respond?.data?.id ?? 0);
      setIsModalNavigateOpen(true);
      // } else {
      //   form.validateFields();
      //   let isTouchAmz = form.isFieldsTouched(['orderNumber']);
      //   let isProductValidAmz =
      //     form.getFieldValue('product').length > 0 &&
      //     form
      //       .getFieldValue('product')
      //       .every((item: any) => Number(item.stockQuantity) > 0);
      //   if (!isTouchAmz || !isProductValidAmz) {
      //     message.error('Please enter for input required');
      //     return;
      //   }
      //   let bodyAmz: any = form.getFieldsValue();
      //   let bodyUseAmz = Object.entries(bodyAmz).reduce(
      //     (a: any, [k, v]) => (!v ? a : ((a[k] = v), a)),
      //     {}
      //   );
      //   bodyUseAmz.orderProducts = bodyUseAmz.product;
      //   delete bodyUseAmz.product;
      //   await ShippingServices.postUpdateShippingAmazon(shippingid, bodyUseAmz);
      //   // setIdDetail(create?.data?.id ?? 0);
      //   setIsModalNavigateOpen(true);
      // }
    } catch (e) {
      message.error(e);
    }

    history.goBack();
  };

  const packageMethod = [
    'Unnecessary',
    'Carton box',
    'Poly mailer',
    'Bubble mailer',
    'Compression',
    'Airpack',
    'Icepack',
    'Envelope',
    'Bubble wrap'
  ];

  const getDetail = async () => {
    const detailShipping = await ShippingServices.getDetailShipping(shippingid);
    console.log(detailShipping);
    let packageMethodUse = detailShipping?.data?.packagingMethod ?? '';

    if (!!packageMethodUse) {
      let isNotDirectInput = packageMethodUse
        .split(',')
        .some((item: string) => packageMethod.includes(item));
      if (!!isNotDirectInput) {
        form.setFieldsValue({ packagingMethod: packageMethodUse.split(',') });
      } else {
        setSelectUse(false);
        form.setFieldsValue({
          packagingMethod: ['Directinput'],
          packageInput: packageMethodUse
        });
      }
    }
    setIdWarehouse(detailShipping?.data?.warehouseId);
    await new Promise((r) => setTimeout(r, 100));
    form.setFieldsValue({
      orderNumber: detailShipping?.data?.orderNumber,
      orderDate: moment(detailShipping?.data?.orderDate),
      saleChannel: detailShipping?.data?.saleChannel,
      buyerName: detailShipping?.data?.buyerName,
      buyerEmail: detailShipping?.data?.buyerEmail,
      recipientName: detailShipping?.data?.recipientName,
      recipientPhone: detailShipping?.data?.recipientPhone ?? '',
      shippingAddress: detailShipping?.data?.shippingAddress,
      detailAddress: detailShipping?.data?.detailAddress,
      detailAddress2: detailShipping?.data?.detailAddress2,
      country: detailShipping?.data?.country,
      city: detailShipping?.data?.city,
      state: detailShipping?.data?.state,
      postalCode: detailShipping?.data?.postalCode,
      dangerous: detailShipping?.data?.dangerous ? 'Yes' : 'No',
      shippingMethod: detailShipping?.data?.shippingMethod,
      sellerComment: !!detailShipping?.data?.sellerComment
        ? detailShipping?.data?.sellerComment
        : 'No comment',
      warehouseId: detailShipping?.data?.warehouse?.name,
      product:
        detailShipping?.data?.orderProducts &&
        detailShipping?.data?.orderProducts.length > 0
          ? detailShipping?.data?.orderProducts.map((item: any) => ({
              id: item.productImported.id,
              productName: item.productImported.productName,
              sku: item.productImported.sku,
              eanUpc: item.productImported.eanUpc,
              asin: item.productImported.asin,
              orderQuantity: item.orderQuantity,
              stockQuantity: item.orderQuantity
            }))
          : []
    });
    // setChannel(detailShipping?.data?.saleChannel);
    // setCountryCode((detailShipping?.data?.recipientCountryCode ?? '').replace('+',''))
    setInfo({
      updated_at: moment(detailShipping?.data?.updated_at)
        .utc(true ?? 9)
        .format('YYYY-MM-DD hh:mm:ss A '),
      status: !!detailShipping?.data?.sellerStatus
        ? getStatusSeller(detailShipping?.data?.sellerStatus)
        : ''
    });
    setRemainQuantity(
      detailShipping?.data?.orderProducts?.reduce(
        (x: number[], n: any) => [...x, n.orderQuantity],
        []
      )
    );
    setSearchValue(detailShipping?.data?.shippingAddress);
  };

  useEffect(() => {
    //    getDetail();
    getListWarehouse(warehouse);
  }, [debounc]);

  useEffect(() => {
    getDetail();
  }, []);

  const getDetailProduct = async (productId: number) => {
    const detailProduct = await ProductService.getDetailProduct(productId);
    let detailProductSearch = detailProduct.data;
    let formProduct = form.getFieldValue('product');
    formProduct[indexProduct] = {
      id: detailProductSearch.id,
      productName: formProduct[indexProduct].productName ?? '',
      sku: detailProductSearch?.sku,
      eanUpc: detailProductSearch?.eanUpc,
      stockQuantity: 0
    };
    form.setFieldsValue({
      product: formProduct
    });

    let remainQty = Array.isArray(remainQuantity)
      ? JSON.parse(JSON.stringify(remainQuantity))
      : [remainQuantity];
    remainQty[indexProduct] =
      Number(detailProductSearch?.inventory?.remainQuantity ?? 0) ?? 0;
    setRemainQuantity(remainQty);
  };

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div>
        <Card
          bordered={false}
          className="admin-card update-shipping"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              marginTop: '20px',
              padding: '0 1rem 2rem 1rem',
              borderRadius: '7px'
            }}
          >
            <div
              style={{
                padding: '1.5rem 1rem',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: 'solid #f0f2f5'
              }}
            >
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  <strong>Update Date :</strong> &nbsp;{info.updated_at}
                </div>
                <Button className="renueProduct">{info.status}</Button>
              </div>
            </div>
            <div style={{ marginTop: '10px', textAlign: 'end' }}>
              <Button
                style={{
                  border: 0,
                  borderBottom: '1px solid black',
                  padding: '2px',
                  marginRight: '15px'
                }}
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                저장하기
              </Button>
            </div>
            <Form
              onKeyPress={(e) => {
                e.key === 'Enter' && e.preventDefault();
              }}
              form={form}
              name="basic-form"
              layout="vertical"
            >
              <Spin spinning={isLoad}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    marginBottom: '1rem'
                  }}
                >
                  <Form.Item
                    label="주문 번호"
                    name="orderNumber"
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                    rules={[
                      {
                        required: true,
                        message: '주문번호를 입력해주세요.'
                      }
                    ]}
                  >
                    {channelUse === 'Amazoins' ? (
                      <AutoComplete
                        style={{ width: '100%' }}
                        getPopupContainer={(node) => node}
                        options={optionOrder}
                        onSearch={(e) => {
                          setOrder(e);
                        }}
                      />
                    ) : (
                      <Input />
                    )}
                  </Form.Item>
                  <Form.Item
                    label="주문 날짜"
                    name="orderDate"
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                    rules={[
                      {
                        required: channelUse === 'Amazoins' ? false : true,
                        message: '주문날짜를 선택해주세요'
                      },
                      {
                        type: 'date',
                        message: 'Only enter date'
                      }
                    ]}
                  >
                    <DatePicker
                      format={'YYYY.MM.DD'}
                      style={{ width: '100%' }}
                      disabled={channelUse === 'Amazoins'}
                    />
                  </Form.Item>
                  <Form.Item
                    label="판매 채널"
                    name="saleChannel"
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                    rules={[
                      {
                        required: true,
                        message: '판매 채널을 선택해주세요'
                      }
                    ]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Select"
                      onChange={(e) => {
                        if (channelUse === 'Amazoins' || e === 'Amazoins') {
                          form.resetFields();
                          form.setFieldsValue({
                            saleChannel: e
                          });
                        }
                        setChannelUse(e);
                      }}
                    >
                      <Select.Option value="Amazon">Amazon</Select.Option>
                      <Select.Option value="Ebay">Ebay</Select.Option>
                      <Select.Option value="Ratuken">Rakuten</Select.Option>
                      <Select.Option value="QOO10">Qoo10</Select.Option>
                      <Select.Option value="OfficeOnlineMall">
                        Office Online Mall
                      </Select.Option>
                      <Select.Option value="Others">Others</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    marginBottom: '1rem'
                  }}
                >
                  <Form.Item
                    label="구매자 이름"
                    name="buyerName"
                    rules={[
                      {
                        required: channelUse === 'Amazoins' ? false : true,
                        message: '구매자 이름을 입력해주세요.'
                      },
                      {
                        pattern: new RegExp(/(\S){1}/g),
                        // new RegExp(/^[A-Za-z\s][A-Za-z0-9\s\&\,\(\)\.]*$/)
                        message: '공백만 입력하지 마세요.'
                      }
                    ]}
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                  >
                    <Input
                      maxLength={20}
                      disabled={channelUse === 'Amazoins'}
                    />
                  </Form.Item>
                  <Form.Item
                    label="구매자 이메일"
                    name="buyerEmail"
                    rules={[
                      {
                        type: 'email',
                        message: '입력하신 이메일이 유효하지 않습니다!'
                      },
                      {
                        required: channelUse === 'Amazoins' ? false : true,
                        message: '이메일은 필수 입력 조건입니다.'
                      }
                    ]}
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                  >
                    <Input disabled={channelUse === 'Amazoins'} />
                  </Form.Item>
                </div>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    paddingBottom: '1rem',
                    borderBottom: '1px solid #f0f2f5'
                  }}
                >
                  <div>
                    <Form.Item
                      label="수취자 이름"
                      name="recipientName"
                      rules={[
                        {
                          required: channelUse === 'Amazoins' ? false : true,
                          message: '수취자 이름은 필수 입력 조건입니다.'
                        }
                      ]}
                      style={{ justifyItems: 'center', padding: '0 1rem' }}
                    >
                      <Input
                        maxLength={20}
                        disabled={channelUse === 'Amazoins'}
                      />
                    </Form.Item>
                    <div style={{ padding: '0 1rem' }}>
                      <CountryPhoneInput
                        placeholder="Please enter number only"
                        title="수취자 연락처"
                        name="recipientPhone"
                        onchange={(value) => {
                          form.setFieldsValue({
                            recipientCountryCode: value
                          });
                        }}
                        phoneNumberRules={[
                          {
                            required: channelUse === 'Amazoins' ? false : true,
                            message: '수취자 연락처는 필수 입력 조건입니다'
                          },
                          {
                            max: 20,
                            message: '전화번호 최대 길이는 20자입니다.'
                          }
                        ]}
                      />
                    </div>
                    <Form.Item
                      name="recipientCountryCode"
                      style={{ display: 'none' }}
                    ></Form.Item>
                  </div>
                  <div
                    style={{
                      gridColumn: 'span 2 / span 2',
                      display: 'grid',
                      gridTemplateColumns: 'repeat(6, minmax(0, 1fr))'
                    }}
                  >
                    <Form.Item
                      name="country"
                      label="배송 국가/주소"
                      style={{
                        justifyItems: 'center',
                        gridColumn: 'span 2 / span 2',
                        padding: '0 0.2rem 0.5rem 1rem'
                      }}
                      rules={[
                        {
                          required: true,
                          message: '배송 국가/주소 입력해주세요.'
                        }
                      ]}
                    >
                      <Input disabled placeholder="Country" />
                    </Form.Item>
                    <Form.Item
                      label="　"
                      name="shippingAddress"
                      style={{
                        justifyItems: 'center',
                        gridColumn: 'span 4 / span 4',
                        padding: '0 1rem 0.5rem 0.2rem'
                      }}
                      rules={[
                        {
                          message: '배송 주소를 입력해주세요.'
                        },
                        {
                          pattern: new RegExp(
                            /^[A-Za-z0-9\s][A-Za-z0-9\s\/\&\,\-\@\!\#\+\(\)\.]*$/
                          ),
                          message: '영문만 입력 가능'
                        }
                      ]}
                    >
                      <div ref={ref}>
                        <Input
                          className="border-input"
                          value={searchValue}
                          onChange={handleInput}
                          placeholder="Search Places ..."
                          disabled={channelUse === 'Amazoins'}
                        />
                        {status === 'OK' && channelUse !== 'Amazoins' && (
                          <ul>{renderSuggestions()}</ul>
                        )}
                      </div>
                    </Form.Item>
                    <Form.Item
                      name="detailAddress2"
                      style={{
                        justifyItems: 'center',
                        paddingLeft: '1rem',
                        gridColumn: 'span 3 / span 3'
                      }}
                    >
                      <Input placeholder="More detail adress" />
                    </Form.Item>
                    <Form.Item
                      name="detailAddress"
                      style={{
                        justifyItems: 'center',
                        paddingLeft: '0.4rem',
                        paddingRight: '1rem',
                        gridColumn: 'span 3 / span 3'
                      }}
                    >
                      <Input
                        disabled
                        placeholder="Apartment, suite, unite, building, floor, etc."
                      />
                    </Form.Item>
                    <Form.Item
                      name="city"
                      style={{
                        justifyItems: 'center',
                        paddingLeft: '1rem',
                        paddingRight: '0.4rem',
                        gridColumn: 'span 2 / span 2'
                      }}
                    >
                      <Input disabled placeholder="Town/City" />
                    </Form.Item>
                    <Form.Item
                      name="state"
                      style={{
                        justifyItems: 'center',
                        paddingRight: '0.4rem',
                        gridColumn: 'span 2 / span 2'
                      }}
                    >
                      <Input disabled placeholder="County/State" />
                    </Form.Item>
                    <Form.Item
                      name="postalCode"
                      style={{
                        justifyItems: 'center',
                        paddingRight: '1rem',
                        gridColumn: 'span 2 / span 2'
                      }}
                    >
                      <Input placeholder="Post code" />
                    </Form.Item>
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      // padding: '0.5rem 0.5rem 0.5rem 1.5rem',
                      margin: '1rem'
                      // backgroundColor: '#F9F9F9',
                      // borderRadius: '1rem'
                    }}
                  >
                    {channelUse !== 'Amazoins' && (
                      <Form.Item
                        name="warehouseId"
                        label="물류센터명"
                        rules={[
                          {
                            required: channelUse === 'Amazoins' ? false : true,
                            message: '창고에 들어가주세요!'
                          }
                        ]}
                        style={{ visibility: 'hidden', height: 0 }}
                      >
                        <AutoComplete
                          disabled={channelUse === 'Amazoins'}
                          getPopupContainer={(node) => node}
                          options={option}
                          onSearch={(e) => {
                            setWarehouse(e);
                          }}
                        />
                      </Form.Item>
                    )}
                    <Form.List name="product">
                      {(fields, { add, remove }) => {
                        return (
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(13, minmax(0, 1fr))',
                              gap: '1rem'
                            }}
                          >
                            <div
                              style={{
                                justifyItems: 'center',
                                gridColumn: 'span 13 / span 13'
                              }}
                            >
                              {(fields || []).map((field, index, ...rest) => (
                                <div
                                  style={{
                                    display: 'flex',
                                    marginBottom: '1rem',
                                    backgroundColor: '#F9F9F9',
                                    borderRadius: '1rem',
                                    padding: '0.5rem 0.5rem 1.5rem 1.5rem'
                                  }}
                                  key={index + 100}
                                >
                                  {fields.length > 1 &&
                                    channelUse !== 'Amazoins' && (
                                      <Button
                                        htmlType="button"
                                        className="btn-remove"
                                        block
                                        style={{
                                          marginTop: '1rem',
                                          width: '2rem',
                                          borderRadius: '100%',
                                          backgroundColor: '#2B2C51',
                                          color: 'white',
                                          display: 'none'
                                        }}
                                        type="dashed"
                                        icon={<MinusOutlined />}
                                        onClick={() => {
                                          let a = remainQuantity;
                                          a.splice(index, 1);
                                          setRemainQuantity(a);
                                          remove(field.name);
                                        }}
                                      />
                                    )}
                                  {channelUse !== 'Amazoins' && (
                                    <Form.Item
                                      label="id"
                                      name={[field.name, 'id']}
                                      style={{
                                        justifyItems: 'center',
                                        padding: '0 1rem',
                                        width: '20%',
                                        display: 'none'
                                      }}
                                    >
                                      <Input disabled />
                                    </Form.Item>
                                  )}
                                  <div style={{ width: '40%' }}>
                                    <Form.Item
                                      label="상품명"
                                      name={[field.name, 'productName']}
                                      rules={[
                                        {
                                          required: false,
                                          message: '제품명을 입력해주세요!'
                                        }
                                      ]}
                                      style={{
                                        justifyItems: 'center'
                                        //   padding: '0 1rem',
                                        // marginLeft:
                                        //   fields.length > 1 ? '2rem' : '0'
                                      }}
                                    >
                                      {/* <Input disabled={idWarehouse === 0} 
                                                                          onChange={(e)=>{
                                                                              setInputProduct(e.target.value)
                                                                              setIndexProduct(index)
                                                                              }
                                                                          }
                                                                      /> */}
                                      {channelUse !== 'Amazoins' ? (
                                        <AutoComplete
                                          style={{ width: '100%' }}
                                          getPopupContainer={(node) => node}
                                          disabled
                                          options={suggestProduct}
                                          onSearch={(e) => {
                                            if (!e && !inputProduct) {
                                              setIndexProduct(index);
                                              getListProduct(idWarehouse, '');
                                            } else {
                                              setInputProduct(e);
                                              setIndexProduct(index);
                                            }
                                          }}
                                          onFocus={(e: any) => {
                                            let proName =
                                              form.getFieldValue('product')[
                                                index
                                              ].productName ?? '';
                                            let id =
                                              form.getFieldValue('product')[
                                                index
                                              ].id ?? '';

                                            if (indexProduct !== index) {
                                              if (!!proName || e.target.value) {
                                                if (
                                                  proName !== e.target.value
                                                ) {
                                                  setInputProduct(
                                                    e.target.value ?? proName
                                                  );
                                                } else {
                                                  if (id === 0) {
                                                    getListProduct(
                                                      idWarehouse,
                                                      proName
                                                    );
                                                    return;
                                                  }
                                                  setSuggestProduct([]);
                                                  return;
                                                }
                                              } else setInputProduct('');
                                            } else if (e.target.value) {
                                              if (!proName) {
                                                setInputProduct(e.target.value);
                                              }
                                              return;
                                            } else if (!inputProduct) {
                                              setSuggestProduct([]);
                                              // setIndexProduct(index)
                                              getListProduct(idWarehouse, '');
                                              return;
                                            } else {
                                              return;
                                            }
                                            setIndexProduct(index);
                                          }}
                                        />
                                      ) : (
                                        <Input disabled />
                                      )}
                                    </Form.Item>
                                    {/* {(suggestProduct.length >0 && index === indexProduct) && <ul style={{marginLeft:indexProduct ==0 ? "3rem" :'1rem'}}>{renderSuggestProduct()}</ul>} */}
                                  </div>
                                  <Form.Item
                                    label="SKU"
                                    name={[field.name, 'sku']}
                                    style={{
                                      justifyItems: 'center',
                                      padding: '0 1rem',
                                      width: '20%'
                                    }}
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                  {channelUse !== 'Amazoins' && (
                                    <Form.Item
                                      label="EAN/UPC"
                                      name={[field.name, 'eanUpc']}
                                      style={{
                                        justifyItems: 'center',
                                        padding: '0 1rem',
                                        width: '20%',
                                        display:
                                          channelUse === 'Amazoins'
                                            ? 'none'
                                            : ''
                                      }}
                                    >
                                      <Input disabled />
                                    </Form.Item>
                                  )}
                                  {channelUse === 'Amazoins' && (
                                    <Form.Item
                                      label="Asin"
                                      name={[field.name, 'asin']}
                                      style={{
                                        justifyItems: 'center',
                                        padding: '0 1rem',
                                        width: '20%',
                                        display:
                                          channelUse === 'Amazoins'
                                            ? ''
                                            : 'none'
                                      }}
                                      rules={[
                                        {
                                          required:
                                            channelUse === 'Amazoins'
                                              ? true
                                              : false,
                                          message: '제품의 asin이 필요합니다'
                                        }
                                      ]}
                                    >
                                      <Input disabled />
                                    </Form.Item>
                                  )}
                                  <Form.Item
                                    label="수량"
                                    name={[field.name, 'stockQuantity']}
                                    style={{
                                      justifyItems: 'center',
                                      padding: '0 1rem',
                                      width: '14%'
                                    }}
                                  >
                                    <InputNumber
                                      max={remainQuantity[index]}
                                      min={0}
                                      disabled
                                    />
                                  </Form.Item>
                                  <div
                                    style={{
                                      width: 'max-content',
                                      backgroundColor: '#2B2C51',
                                      padding: '1px 10px',
                                      borderRadius: '1rem',
                                      textAlign: 'center',
                                      color: 'white',
                                      height: '1.8rem',
                                      display: 'none' // hidden
                                    }}
                                  >
                                    남은 수량 : &nbsp;{remainQuantity[index]}
                                  </div>
                                </div>
                              ))}
                            </div>
                            {channelUse !== 'Amazoins' && (
                              <Button
                                htmlType="button"
                                className="btn-add"
                                block
                                style={{
                                  marginTop: '1rem',
                                  width: '2rem',
                                  borderRadius: '100%',
                                  backgroundColor: '#2B2C51',
                                  color: 'white',
                                  display: 'none' // hidden
                                }}
                                type="dashed"
                                icon={<PlusOutlined />}
                                onClick={() =>
                                  add({
                                    id: 0,
                                    productName: '',
                                    sku: '',
                                    eanUpc: '',
                                    stockQuantity: 0
                                  })
                                }
                              />
                            )}
                          </div>
                        );
                      }}
                    </Form.List>
                  </div>
                  <div style={{ borderBottom: '1px solid #f0f2f5' }}></div>
                  <div>
                    <div style={{ display: 'flex', marginBottom: '1rem' }}>
                      <div
                        style={{
                          justifyItems: 'center',
                          padding: '0 1rem',
                          width: '20%'
                        }}
                      >
                        <Form.Item
                          label="포장 방법"
                          name="packagingMethod"
                          rules={[
                            {
                              required:
                                channelUse === 'Amazoins' ? false : true,
                              message: '포장방법을 선택해주세요'
                            }
                          ]}
                        >
                          <Select
                            mode="multiple"
                            showArrow
                            placeholder="Select"
                            getPopupContainer={(node) => node}
                            onChange={(e: any) => {
                              if (e.includes('Directinput')) {
                                form.setFieldsValue({
                                  packagingMethod: 'Directinput'
                                });
                                setSelectUse(false);
                              } else {
                                setSelectUse(true);
                              }
                            }}
                          >
                            {!!selectUse ? (
                              <>
                                <Select.Option value="Unnecessary">
                                  Unnecessary
                                </Select.Option>
                                <Select.Option value="Carton box">
                                  {' '}
                                  Carton box
                                </Select.Option>
                                <Select.Option value="Poly mailer">
                                  Poly mailer{' '}
                                </Select.Option>
                                <Select.Option value="Bubble mailer">
                                  {' '}
                                  Bubble mailer
                                </Select.Option>
                                <Select.Option value="Compression">
                                  Compression
                                </Select.Option>
                                <Select.Option value="Airpack">
                                  Airpack
                                </Select.Option>
                                <Select.Option value="Icepack">
                                  Icepack
                                </Select.Option>
                                <Select.Option value="Envelope">
                                  Envelope
                                </Select.Option>
                                <Select.Option value="Bubble wrap">
                                  Bubble wrap
                                </Select.Option>
                                <Select.Option value="Directinput">
                                  Direct input{' '}
                                </Select.Option>
                              </>
                            ) : (
                              <Select.Option value="Directinput">
                                Direct input{' '}
                              </Select.Option>
                            )}
                          </Select>
                        </Form.Item>
                        {!selectUse && (
                          <Form.Item
                            name="packageInput"
                            style={{ padding: '0.25rem 2.125rem 0 0' }}
                          >
                            <Input />
                          </Form.Item>
                        )}
                      </div>
                      <Form.Item
                        label="위험 상품 포함 여부"
                        name="dangerous"
                        rules={[
                          {
                            required: channelUse === 'Amazoins' ? false : true,
                            message: '제품이 위험합니까?'
                          }
                        ]}
                        style={{
                          justifyItems: 'center',
                          padding: '0 1rem',
                          width: '20%'
                        }}
                      >
                        <Select
                          placeholder="Select"
                          getPopupContainer={(node) => node}
                        >
                          <Select.Option value="2">No</Select.Option>
                          <Select.Option value="1">Yes</Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="배송 방법"
                        name="shippingMethod"
                        rules={[
                          {
                            required: channelUse === 'Amazoins' ? false : true,
                            message: '배송방법을 선택해주세요'
                          }
                        ]}
                        style={{
                          justifyItems: 'center',
                          padding: '0 1rem',
                          width: '20%'
                        }}
                      >
                        <Select
                          placeholder="Select"
                          getPopupContainer={(node) => node}
                        >
                          <Select.Option value="Economic">
                            Economic
                          </Select.Option>
                          <Select.Option value="Standard">
                            Standard
                          </Select.Option>
                          <Select.Option value="Express">Express</Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                    <div>
                      <Form.Item
                        name="sellerComment"
                        style={{
                          justifyItems: 'center',
                          padding: '0 1rem'
                          // width: '60%'
                        }}
                      >
                        <Input.TextArea
                          style={{ padding: '2rem 1rem 1rem 1rem' }}
                        />
                      </Form.Item>
                      <div
                        style={{
                          position: 'absolute',
                          left: '1.5rem',
                          bottom: '4rem',
                          zIndex: '10',
                          fontWeight: 'bold'
                        }}
                      >
                        물류센터에게 보내는 코멘트
                      </div>
                    </div>
                  </div>
                </div>
              </Spin>
            </Form>
          </div>
        </Card>
        <Popup
          styleBackground="white"
          styleColor="#2A2D51"
          textCancel="취소"
          textOk="확인"
          visible={isModalOpen}
          title="저장 하시겠습니까?"
          action_oke={() => {
            UpdateShipping('Request');
            setIsModalOpen(false);
          }}
          action_cancel={() => {
            setIsModalOpen(false);
          }}
        />
      </div>
    </>
  );
};
export default UpdateShipping;
